import { createPinia, PiniaPlugin } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { easyDeepClone } from '@/common/utils/common'

const pinia = createPinia()

export const piniaReset: PiniaPlugin = ({ store }) => {
    const initialState = easyDeepClone(store.$state)
    store.$reset = () => {
        store.$patch($state => Object.assign($state, initialState))
    }
}
// 修复setup模式$reset无效的问题
pinia.use(piniaReset)

// 将插件添加到 pinia 实例上
pinia.use(piniaPluginPersistedstate)

export default pinia
